module.exports = __webpack_public_path__ + "img/efectivo.82f33598.svg";